import { Button } from "./ui/button";

export function AppErrorFallback({ resetError }) {
  return (
    <main className="min-h-screen flex items-center justify-center p-6 bg-[#FAF7F2]" data-testid="app-error-fallback">
      <div className="ga-card max-w-md w-full p-8 text-center">
        <div className="font-display text-2xl font-bold text-slate-900">Qualcosa è andato storto</div>
        <p className="mt-3 text-sm text-slate-600">L'errore è stato registrato automaticamente. Riprova o ricarica la pagina.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button className="rounded-full" onClick={resetError} data-testid="app-error-retry">Riprova</Button>
          <Button variant="outline" className="rounded-full" onClick={() => window.location.reload()} data-testid="app-error-reload">Ricarica</Button>
        </div>
      </div>
    </main>
  );
}
